// ไฟล์: frontend/src/services/auth.js
import { authAPI } from './api';

// บริการสำหรับการจัดการ token และ user data
const authService = {
  // ตรวจสอบว่ามีการล็อกอินแล้วหรือไม่
  isAuthenticated: () => {
    return localStorage.getItem('token') !== null;
  },
  
  // ตรวจสอบว่าเป็นแอดมินหรือไม่
  isAdmin: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'admin';
  },
  
  // ตรวจสอบว่าเป็นครูหรือไม่
  isTeacher: () => {
    const user = authService.getCurrentUser();
    return user && user.role === 'teacher';
  },
  
  // ล็อกอิน
  login: async (username, password) => {
    try {
      const response = await authAPI.login(username, password);
      const { token, user } = response.data;
      
      // เก็บ token และข้อมูลผู้ใช้ใน localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      return user;
    } catch (error) {
      throw error;
    }
  },
  
  // ล็อกเอาต์
  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },
  
  // ดึงข้อมูลผู้ใช้ปัจจุบัน
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    return JSON.parse(userStr);
  },
  
  // อัปเดตข้อมูลผู้ใช้ใน localStorage
  updateUserData: (userData) => {
    const currentUser = authService.getCurrentUser();
    if (currentUser && currentUser.id === userData.id) {
      const updatedUser = { ...currentUser, ...userData };
      localStorage.setItem('user', JSON.stringify(updatedUser));
    }
  }
};

export default authService;